import { LitElement, html } from 'lit';
import { store } from '../store.js';
import { auth } from '../services/auth.js';
import { showSuccess, showError } from '../components/toast-notification.js';

class SettingsView extends LitElement {
  static properties = {
    _targetServings: { state: true },
  };

  createRenderRoot() { return this; }

  constructor() {
    super();
    this._targetServings = store.getSettings().targetServings || 2.5;
  }

  connectedCallback() {
    super.connectedCallback();
    this._onUpdate = (settings) => {
      this._targetServings = settings.targetServings || 2.5;
    };
    store.on('settings-updated', this._onUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    store.off('settings-updated', this._onUpdate);
  }

  async _saveSettings(e) {
    e.preventDefault();
    const input = this.renderRoot.querySelector('#target-servings');
    const value = parseFloat(input.value);

    if (isNaN(value) || value <= 0) {
      showError('Please enter a valid number greater than 0');
      return;
    }

    try {
      await store.updateSettings({ targetServings: value });
      showSuccess('Settings saved');
    } catch (error) {
      console.error('Error saving settings:', error);
      showError('Failed to save settings');
    }
  }

  _signOut() {
    auth.signOut();
  }

  render() {
    return html`
      <div class="max-w-4xl mx-auto px-4 py-6 md:ml-64">
        <h1 class="text-3xl font-bold text-gray-900 mb-6">Settings</h1>

        <div class="bg-white rounded-lg shadow p-6 mb-6">
          <h2 class="text-xl font-semibold text-gray-900 mb-4">Meal Planning</h2>
          <form @submit=${this._saveSettings} class="space-y-4">
            <div>
              <label for="target-servings" class="block text-sm font-medium text-gray-700 mb-2">
                Target Servings
              </label>
              <p class="text-sm text-gray-500 mb-2">
                When generating shopping lists, ingredient quantities are scaled to this number of servings.
              </p>
              <input
                type="number"
                id="target-servings"
                step="0.5"
                min="0.5"
                .value=${String(this._targetServings)}
                class="w-full max-w-xs px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
            </div>
            <button type="submit" class="bg-blue-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-blue-700 transition-colors">
              Save Settings
            </button>
          </form>
        </div>

        <div class="bg-white rounded-lg shadow p-6 mb-6">
          <h2 class="text-xl font-semibold text-gray-900 mb-4">Account</h2>
          <p class="text-gray-600 mb-4">Signed in as <span class="font-medium">${auth.getUserEmail()}</span></p>
          <button @click=${this._signOut} class="bg-red-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-red-700 transition-colors">
            Sign Out
          </button>
        </div>
      </div>
    `;
  }
}

customElements.define('settings-view', SettingsView);
